import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'which_of_the_following_topics_are_included_win_the_facs_written_1'

export const dataPointDefinition = {
  retracedId: 'which_of_the_following_topics_are_included_win_the_facs_written_1',
  name: "Which of the following topics are included within the facility's written policies and procedures for child labor and young workers?",
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'FACILITY_MINIMUM_AGE_REQUIREMENT',
      text: 'Facility minimum age requirement',
      externalIds: [
        {
          id: 'ms-1--3-1x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'FACILITY_MINIMUM_AGE_REQUIREMENTS_FOR_CERTAIN_TYPES_OF_WORKERS_',
      text: 'Facility minimum age requirements for certain types of workers (if applicable)',
      externalIds: [
        {
          id: 'ms-1--3-2x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'AGE_VERIFICATION_PROCESS',
      text: 'Age Verification Process',
      externalIds: [
        {
          id: 'ms-1--3-3x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'REMEDIATION_FOR_CHILD_LABOR_FOR_WHEN_CHILDREN_UNDER_THE_LEGAL_M',
      text: 'Remediation for child labor (for when children under the legal minimum working age are found to be working for the facility)',
      externalIds: [
        {
          id: 'ms-1--3-4x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'CHILDREN_VISITING_FACILITY_PRODUCTION_AREAS_I_E_FOR_WHEN_THOSE_',
      text: 'Children visiting facility production areas (i.e. for when those under the legal working are visiting the production floor)',
      externalIds: [
        {
          id: 'ms-1--3-5x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WORK_RESTRICTIONS_FOR_YOUNG_WORKERS',
      text: 'Work restrictions for young workers',
      externalIds: [
        {
          id: 'ms-1--3-6x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WORK_RESTRICTIONS_FOR_APPRENTICES_INTERNS_TRAINEES',
      text: 'Work restrictions for apprentices/interns/trainees',
      externalIds: [
        {
          id: 'ms-1--3-7x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'OTHER',
      text: 'Other',
      externalIds: [
        {
          id: 'ms-1--3-8x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'If other, please describe:',
        externalIds: [
          {
            id: 'ms-1--3-8f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'FACILITY_MINIMUM_AGE_REQUIREMENT',
                'FACILITY_MINIMUM_AGE_REQUIREMENTS_FOR_CERTAIN_TYPES_OF_WORKERS_',
                'AGE_VERIFICATION_PROCESS',
                'REMEDIATION_FOR_CHILD_LABOR_FOR_WHEN_CHILDREN_UNDER_THE_LEGAL_M',
                'CHILDREN_VISITING_FACILITY_PRODUCTION_AREAS_I_E_FOR_WHEN_THOSE_',
                'WORK_RESTRICTIONS_FOR_YOUNG_WORKERS',
                'WORK_RESTRICTIONS_FOR_APPRENTICES_INTERNS_TRAINEES',
                'OTHER',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ms-pla-11',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 18760,
  sectionId: '2.2.6.10',
  impactArea: 'Policies and Procedures',
  impactAreaId: 'POLICIES_AND_PROCEDURES',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
